import { defineComponent } from 'vue';
import { EnvironmentOutlined } from '@ant-design/icons-vue';
import { LoginService } from '@/services/login.service';
import { UserService } from '@/services/user.service';
import { useService } from '@kaokei/use-vue-service';
import { SHOW_BRAND } from '@/utils';
import GetAccountFormVue from './GetAccountForm.vue';
export default defineComponent({
  name: 'LoginDialog',
  components: {
    EnvironmentOutlined: EnvironmentOutlined,
    GetAccountFormVue: GetAccountFormVue
  },
  props: {
    showCloseBtn: {
      type: Boolean,
      default: true
    }
  },
  setup: function (props) {
    var userService = useService(UserService);
    var loginService = useService(LoginService);
    // ============================================
    return {
      userService: userService,
      loginService: loginService,
      SHOW_BRAND: SHOW_BRAND,
      props: props
    };
  }
});